module.exports = "<router-outlet><app-spinner></app-spinner></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/auth/auth.component.html
// module id = ./src/app/layouts/auth/auth.component.html
// module chunks = main